export const IMGIX_URL_PATH = {
  PRD: 'https://koro-foodroots.imgix.net/',
  STG: 'https://koro-foodroots.imgix.net/',
  DEV: 'https://dev-koro-foodroots.imgix.net/'
};

/**
 * Get the imgix URL based on the firebase bucket URL, to match the environment
 * @param bucket
 * @returns
 */
export const getImgixUrlFromFirebaseBucket = (_bucket: string): string => {
  return IMGIX_URL_PATH['PRD'];
};
